import React, { Component, Fragment } from 'react';
import BookingsList from './BookingsList';

export default class BookingPage extends Component {
  render() {
    return (
      <Fragment>
        <BookingsList />
      </Fragment>
    );
  }
}
